import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38137b4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "test-start-container" }
const _hoisted_2 = { id: "top-container" }
const _hoisted_3 = { id: "lower-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingTestPanel = _resolveComponent("LoadingTestPanel")!
  const _component_StartTestPanel = _resolveComponent("StartTestPanel")!
  const _component_ErrorPanel = _resolveComponent("ErrorPanel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.getTitle()), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.displayType === _ctx.loadingDisplayType)
          ? (_openBlock(), _createBlock(_component_LoadingTestPanel, {
              key: 0,
              class: "display-panel"
            }))
          : (_ctx.displayType === _ctx.startDisplayType)
            ? (_openBlock(), _createBlock(_component_StartTestPanel, {
                key: 1,
                class: "display-panel",
                onStartButtonClicked: _ctx.handleStartTest
              }, null, 8, ["onStartButtonClicked"]))
            : (_ctx.displayType === _ctx.errorDisplayType)
              ? (_openBlock(), _createBlock(_component_ErrorPanel, {
                  key: 2,
                  class: "display-panel",
                  onRetryClicked: _ctx.handleRetry
                }, null, 8, ["onRetryClicked"]))
              : _createCommentVNode("", true)
      ])
    ])
  ]))
}